<template>
  <b-card class="bg-light">
    <b-row v-for="(t, idxi) in itinerario" :key="idxi">
      <b-col cols="12" md="4">
        <p class="text-center my-0">
          {{ t.salida.aeropuerto.codigo }}
        </p>
        <p class="text-center my-0">
          <small> {{ t.salida.fecha | formatDate2Cliente }} hs </small>
        </p>
      </b-col>
      <b-col cols="12" md="4">
        <p class="text-center my-0">
          <img
            :src="'https://www.allseasons.tur.ar/ws/utiles/img/aerolineas/' + t.aerolinea.codigo + '.png'"
            class="icon-aereolinea-as"
            :alt="'Aerolinea ' + t.aerolinea.codigo"
          />
        </p>
        <p class="text-center my-0">
          <small> Clase {{ t.clase }} </small>
        </p>
        <p class="text-center my-0">
          <small> Nro. vuelo {{ t.nroVuelo }} </small>
        </p>
      </b-col>
      <b-col cols="12" md="4">
        <p class="text-center my-0">
          {{ t.llegada.aeropuerto.codigo }}
        </p>
        <p class="text-center my-0">
          <small> {{ t.llegada.fecha | formatDate2Cliente }} hs </small>
        </p>
      </b-col>
      <b-col cols="12" md="12" v-if="idxi != itinerario.length - 1">
        <hr />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  props: ["itinerario"],
  mounted() {},
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
